import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import EllipsisIcon from '@wix/da-ds/pkg/Icons/Ellipsis';
import {
  DropdownOption,
  NullableDropdownGroup,
} from '@wix/da-shared-react/pkg/Dropdown/types';
import IconButtonWithContextMenu from '@wix/da-shared-react/pkg/Dropdown/Preset/IconButtonWithContextMenuV2';
import {
  canPerformPageAction,
  getIsGroupMember,
} from '../../../../../../../selectors/groups';
import { PagePriv } from '../../../../../../../../types/pagePrivileges';
import { Url } from '@wix/da-url';
import { getProfileOwnerUser } from '../../../../../../../selectors/users';

interface Props {}

const GroupMoreMenu: React.FC<Props> = () => {
  const { t } = useTranslation();
  const menuItems: NullableDropdownGroup[] = [];

  const isGroupMember = useSelector(getIsGroupMember);
  const canRespondToGroupNotifications = useSelector(state =>
    canPerformPageAction(state, PagePriv.CAN_RESPOND_TO_GROUP_NOTIFICATIONS)
  );
  const profileOwnerUser = useSelector(getProfileOwnerUser);

  const communicationMenuGroup = {
    items: [] as DropdownOption[],
  };
  const farewellMenuGroup = {
    items: [] as DropdownOption[],
  };

  if (canRespondToGroupNotifications) {
    communicationMenuGroup.items.push({
      label: t('groups.admin.groupNotifications'),
      link: Url.groupNotificationsLink(profileOwnerUser.userId),
    });
  }

  communicationMenuGroup.items.push({
    label: t('groups.sendInvite'),
  });

  if (isGroupMember) {
    farewellMenuGroup.items.push({
      label: t('groups.leaveGroup'),
    });
  }

  menuItems.push(communicationMenuGroup);
  menuItems.push(farewellMenuGroup);

  return (
    <IconButtonWithContextMenu
      size="large"
      items={menuItems}
      icon={EllipsisIcon}
      placement="bottom-end"
    />
  );
};
GroupMoreMenu.displayName = 'GroupMoreMenu';

export default GroupMoreMenu;
